var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1724138,0.827586207 C15.629477,1.28464945 15.629477,2.02569538 15.1724138,2.48275862 L2.48275862,15.1724138 C2.02569538,15.629477 1.28464945,15.629477 0.827586207,15.1724138 C0.370522966,14.7153506 0.370522966,13.9743046 0.827586207,13.5172414 L13.5172414,0.827586207 C13.9743046,0.370522966 14.7153506,0.370522966 15.1724138,0.827586207 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.827586207,0.827586207 C0.370522966,1.28464945 0.370522966,2.02569538 0.827586207,2.48275862 L13.5172414,15.1724138 C13.9743046,15.629477 14.7153506,15.629477 15.1724138,15.1724138 C15.629477,14.7153506 15.629477,13.9743046 15.1724138,13.5172414 L2.48275862,0.827586207 C2.02569538,0.370522966 1.28464945,0.370522966 0.827586207,0.827586207 Z",
    id: "Rectangle"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.5b97b30e6c232195123751655a346f20.svg";
export { ForwardRef as ReactComponent };